import { createContext, useState, useMemo, useContext, useCallback } from 'react'
/**
 * use React Context effectively
 * @see https://kentcdodds.com/blog/how-to-use-react-context-effectively
 */

// context
const SilentPageContext = createContext()

// Provider
const SilentPageProvider = props => {
  const { defaultValue, ...restProps } = props
  const [isSilentPage, setSilentPage] = useState(defaultValue || false)
  const value = useMemo(
    () => ({
      isSilentPage,
      setSilentPage
    }),
    [isSilentPage]
  )

  return (
    <SilentPageContext.Provider
      value={value}
      {...restProps}
    />
  )
}

// Consumer for functional-component,
// It's a custom hook
const useSilentPage = () => {
  const context = useContext(SilentPageContext)
  if (!context) {
    throw new Error('useSilent must be used within a SilentProvider')
  }

  const { isSilentPage, setSilentPage } = context

  const setSilentPageTo = useCallback(
    val => setSilentPage(val),
    [setSilentPage]
  )

  return {
    isSilentPage,
    setSilentPageTo
  }
}

// Consumer for class-component
// It's a hoc
const withSilentPageContext = WrappedCompo => {
  const WithSilentPageCompo = props => {
    const contextValue = useSilentPage()
    return (
      <WrappedCompo
        {...props}
        silentPageContext={contextValue}
      />
    )
  }

  return WithSilentPageCompo
}

export {
  SilentPageProvider,
  useSilentPage,
  withSilentPageContext
}
